<template>
  <div class="data-container">
    <el-row :gutter="20">
      <el-col :span="4">
        <div class="col-bg">
          <div class="col-bg-horn"></div>
          <div>
            <tag-title title="数据监测站点" />
          </div>
          <div class="list">
            <div
              class="name-box"
              :class="{'active':xindex==index}"
              v-for="(item,index) in siteOptions"
              :key="index"
              @click="changeSiteClick(item,index)"
            >
              <span class="site-img"></span>
              <div class="site-text">{{item.siteName}}</div>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="20">
        <div class="col-bg">
          <div class="col-bg-horn"></div>
          <div class="radio-box">
            <el-radio-group class="change-radio" v-model="radio1" @change="alarmDuration">
              <el-radio-button label="12">近12小时</el-radio-button>
              <el-radio-button label="24">近24小时</el-radio-button>
              <el-radio-button label="3">近3天</el-radio-button>
            </el-radio-group>
          </div>
          <tag-title title="传感器预警时长统计" />
          <chart :data="chartData" :start_="start_" :end_="end_"></chart>
          <div class="content-box">共计{{siteCount}}个站点，传感器{{devCount}}个，近24小时内正常状态<span style="color:#16c18c">{{normalCount}}</span>个，预警状态<span style="color:#f9b83f">{{warnCount}}</span>个。</div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import chart from "./compontents/chart";
import tagTitle from "./compontents/tagTitle";
import { alarmDuration, siteDate } from "@/api/analysis/time";
export default {
  components: { chart, tagTitle },

  // 定义属性
  data() {
    return {
      xindex: 0,
      siteOptions: [],
      siteId: "",
      radio1: "12",
      chartParam: {},
      chartData: {
        type: "time",
        list: [],
      },
      siteCount:0,
      devCount:0,
      normalCount:0,
      warnCount:0,
      start_: null,
      end_: null,
    };
  },
  // 计算属性，会监听依赖属性值随之变化
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    siteDate() {
      siteDate({ siteId: this.siteId }).then((res) => {
         this.siteCount = res.data.siteCount
         this.devCount = res.data.realDevList.length
         this.normalCount = 0
         this.warnCount = 0
         res.data.realDevList.forEach(element => {
           if(element.state == 1){
             this.normalCount ++
           }
           if(element.state == 3){
             this.warnCount ++
           }
         });

      });
    },
    changeSiteClick(site, index) {
      this.siteId = site.siteId;
      this.xindex = index;
      this.radio1 = 12;
      this.alarmDuration(12);
      this.siteDate();
    },
    alarmDuration(value) {
      if (value == 12) {
        this.$set(this.chartParam, "unit", "h");
      } else if (value == 24) {
        this.$set(this.chartParam, "unit", "h");
      } else {
        this.$set(this.chartParam, "unit", "d");
      }
      this.$set(this.chartParam, "time", value);
      if (this.siteId) {
        this.$set(this.chartParam, "siteId", this.siteId);
      } else {
        this.$delete(this.chartParam, "siteId");
      }

      alarmDuration(this.chartParam).then((res) => {
        // this.end_ = new Date(
        //   new Date(new Date().toLocaleDateString()).getTime() +
        //     24 * 60 * 60 * 1000
        // ).getTime();
        this.end_ = new Date().getTime();
        if (value == 12) {
          this.start_ = this.end_ - 12 * 3600 * 1000;
          this.$set(this.chartData, "type", "time");
        } else if (value == 24) {
          this.start_ = this.end_ - 24 * 3600 * 1000;
          this.$set(this.chartData, "type", "time");
        } else {
          this.start_ = this.end_ - 3 * 24 * 3600 * 1000;
          this.$set(this.chartData, "type", "data");
        }
        this.$set(this.chartData, "list", res.dataList);
      });
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    let sites = this.$store.getters.siteList;
    this.siteOptions = JSON.parse(JSON.stringify(sites));
    // this.siteOptions.unshift({
    //   siteName: "全部站点",
    // });
    this.siteId = this.siteOptions[0].siteId;
    this.alarmDuration(12);
    this.siteDate();
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style lang='scss'>
.data-container {
  margin-top: 30px;
  .col-bg {
    padding: 25px 0;
    background-color: rgba(7, 31, 82, 0.2);
  }
  .radio-box {
    text-align: left;
    margin: 5px 30px;
  }
  .content-box {
    border-style: solid;
    border-color: rgba(249, 186, 63, 0.5);
    color: white;
    border-width: 1px;
    background-color: rgba(249, 186, 63, 0.1);
    margin: 20px 30px;
    font-size: 14px;
    text-align: left;
    padding: 8px 18px;
  }
}
.site-img {
  height: 20px;
  width: 20px;
  background-image: url("../../../static/img/site-default.png");
  vertical-align: middle;
  display: inline-block;
}
.site-text {
  color: white;
  font-size: 14px;
  display: inline-block;
}
.list {
  margin-top: 15px;
  height: calc(100vh - 300px);
  overflow: auto;
  .name-box {
    height: 60px;
    line-height: 60px;
    text-indent: 15px;
    margin: 10px 0;
    font-size: 16px;
    text-align: left;
    cursor: pointer;
    &:hover,
    &.active {
      background-color: #224794;
      border-radius: 2px;
      color: #fff;
      position: relative;
      &::before {
        content: "";
        width: 3px;
        height: 60px;
        background-color: #a4dcf5;
        display: inline-block;
        margin-right: 10px;
        vertical-align: middle;
        position: absolute;
        top: 0;
        left: 0;
      }
      .site-img {
        background-image: url("../../../static/img/site-selected.png");
      }
    }
    .img {
      width: 20px;
      height: 20px;
      display: inline-block;
      background-image: url("../../../static/img/site-default.png");
      vertical-align: middle;
      margin-right: 10px;
    }
  }
}
</style>
